<template>
  <div class="cookie-pitch">
    <p>
      A cookie is a small file put on your device to remember some things as you navigate our website. They fall into several categories.
    </p>

    <div class="cookie-type-header">essential first party cookies</div>
    <ul class="fa-ul">
      <li>
        <i class="fa fa-li fa-check" aria-hidden="true"></i>
        <em>myOscarList</em> creates its own cookies to keep track of information about your session. These are essential to the functionality of the site, so there's no way to turn them off—the site simply won't work without them.
      </li>
    </ul>

    <div class="cookie-type-header">helpful third-party cookies</div>
    <ul class="fa-ul">
      <li>
        <i class="fa fa-li fa-check" aria-hidden="true"></i>
        Our site allows <em>Mixpanel</em> to create cookies as well. Mixpanel is a framework we use for data analytics. We love analytics because it helps the site send us data we use to improve everyone's experience; and we love Mixpanel because they allow us precise control over what information we send to ourselves.
      </li>
    </ul>

    <div class="cookie-type-header">stupid third-party cookies</div>
    <ul class="fa-ul">
      <li>
        <i class="fa fa-li fa-times" aria-hidden="true"></i>
        <em style="color: darkred; text-decoration: underline;">We don't use these.</em> You know these. You search for toasters online, then for the next three weeks you see ads for toasters everywhere. That's the sort of thing stupid third-party cookies are for. We hate that, so we don't use those.
      </li>
    </ul>

<!-- if the user hasn't made a choice about third-party cookies, display the more persuasive choice buttons    -->
    <div v-if="displayChoiceButtons" class="choice-buttons">
      <p>
        We'd appreciate it if you'd allow our site to create some helpful third-party cookies.
      </p>
      <button class="btn btn-sm btn-accept" type="button" @click="accept" :data-bs-dismiss="modal? 'modal' : ''">
        <img :src="`${$imagePathBase}win_icon-gold.svg`" alt="cookie" class="cookie-image"> sure, glad to help!
      </button>
      <button class="btn btn-sm btn-decline" type="button" @click="decline" :data-bs-dismiss="modal? 'modal' : ''">
        no thank you
      </button>
    </div>

    <!-- if the user HAS made a choice about third-party cookies, display the toggle    -->
    <div v-else>
      <div class="choice-toggles">
        <div class="form-check form-switch text-secondary">
          <input class="form-check-input" type="checkbox" id="groupByNomination" v-model="cookieTogglePosition">
          <label class="form-check-label" for="groupByNomination">helpful third-party cookies {{cookieTogglePosition ? 'enabled' : 'disabled'}}</label>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import analytics from "@/analytics";
import {EventBus} from "@/eventBus";

export default {
  name: "CookiePitch",
  props: ["modal"],
  data() {
    return {
      displayChoiceButtons: !analytics.hasSetTrackingPreferences(),
      cookieTogglePosition: analytics.hasOptedInToTracking()
    };
  },
  mounted() {
    EventBus.on('analytics-tracking-preference-updated', () => {
      this.displayChoiceButtons = this.modal || !analytics.hasSetTrackingPreferences();
      this.cookieTogglePosition = analytics.hasOptedInToTracking();
    });
  },
  watch: {
    cookieTogglePosition(_on) {
      //console.log(`cookieTogglePosition = ${_on}`)
      if ( _on ) {
        analytics.optInToTracking();
      } else {
        analytics.optOutOfTracking();
      }
    }
  },
  methods: {
    accept() {
      //console.log('accept');
      if ( !this.modal ) {
        this.displayChoiceButtons = false;
      }
      this.cookieTogglePosition = true;
      analytics.optInToTracking();
    },
    decline() {
      //console.log('decline');
      if ( !this.modal ) {
        this.displayChoiceButtons = false;
      }
      this.cookieTogglePosition = false;
      analytics.optOutOfTracking();
    }
  }
}
</script>


<style scoped>

  .cookie-pitch {
    text-align: left;

    .cookie-type-header {
      text-align: center;
      font-weight: bold;
    }

    .fa-check {
      color: green;
    }

    .fa-times {
      color: darkred;
    }

    .choice-buttons {
      padding: 2em 4em 0 4em;

      text-align: center;
      color: var(--mol-color-gold);
      font-weight: bold;

      .btn-accept {
        display: block;
        margin: 0 auto 0.5em auto;
        width: 200px;
        font-weight: bold;
        color: inherit;
        border-width: 2px;
        border-color: var(--mol-color-gold);

        img {
          height: 2em;
        }

        &:hover {
          box-shadow: 0 0 0 1px var(--mol-color-gold);
        }
      }

      .btn-decline {
        display: block;
        height: 40px;
        width: 200px;
        font-style: italic;
        color: var(--bs-secondary-color);
        margin: 1em auto 0.5em auto;
        border: solid;
        border-width: 1px;
        border-color: var(--bs-secondary-color);

        &:hover {
          box-shadow: 0 0 0 1px slategray;
        }
      }
    }


    .choice-toggles {

      padding: 2em 1em 0 1em;
      font-weight: bold;

      margin-right: auto;
      margin-left: auto;
      width: fit-content;

      .form-switch {
        text-align: left;
        margin: 0;

        .form-check-label {
          color: var(--mol-color-gold);
          &:hover {
            color: var(--bs-link-hover-color);
          }
        }

        .form-check-input {
          border-color: var(--mol-color-gold);
        }
      }
   }
  }
</style>